import { format } from 'date-fns'
import { getJWT, getLocal, getLocalId } from '../Utils/Profile'
import { BASEAPI } from './constants'

const createProduct = async (data: ICreateProductForm) => {
    const commerce = localStorage.getItem('currentUser')
    const commerceData: ICommerceBO = commerce ? JSON.parse(commerce) : null
    const res = await fetch(`${BASEAPI}apimac/api/v1/mac/product/ `, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            Authorization: getJWT(),
        },
        body: JSON.stringify({
            productCategoryID: Number(data.productCategoryID),
            productBrandID: Number(data.productBrandID),
            productMeasureUnit: data.productMeasureUnit,
            productStatusID: 1,
            productName: data.productName,
            fullDescription: data.fullDescription,
            shortDescription: data.shortDescription,
            weight: data.weight && +data.weight.replace(',', '.'),
            photoURL: data.productImage,
            commerceCreatedBy: commerceData.sEstablecimiento + getLocal(),
            isFood: data.isFood,
            isExemptFromIva: false,
            allowChange: false,
            isValid: false,
            isPack: false,
            isPublic: false,
            isExpirable: false,
            isHeavyProduct: false,
            isPreparable: false,
            isPartitionable: false,
            isCreatedByCommerce: false,
            ean: data.ean,
            sku: data.sku,
            inStoreSales: data.inStoreSales,
            salesInApp: data.salesInApp,
        }),
    }).catch((error) => {
        throw new Error(error)
    })
    return JSON.parse(await res.text()) as ILiquidateCreated
}

const liquidateFromCreate = async (data: ILiquidateCreate) => {
    const commerce = localStorage.getItem('currentUser')
    const commerceData: ICommerceBO = commerce ? JSON.parse(commerce) : null
    const res = await fetch(
        `${BASEAPI}apimac/api/v1/mac/product/settlement/ `,
        {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Authorization: getJWT(),
            },
            body: JSON.stringify({
                productCategoryID: Number(data.category),
                productBrandID: Number(data.productBrand),
                productMeasureUnit: data.unit,
                productStatusID: 1,
                productName: data.name,
                fullDescription: data.description,
                shortDescription: data.shortDescription,
                weight: data.quantity,
                photoURL: data.productImage,
                commerceCreatedBy: commerceData.sEstablecimiento + getLocal(),
                dateVoidSettlement: data?.date
                    ? format(data.date, 'yyyy-MM-dd')
                    : null,
                valid: false,
                createdByCommerce: true,
                isFood: data.isFood,
                public: false,
            }),
        }
    )
    return JSON.parse(await res.text()) as ILiquidateCreated
}

const addStock = (
    stock: string,
    productID: number,
    weight: string,
    weightUnit: string,
    f2f = false,
    online = false
) => {
    const commerce = localStorage.getItem('currentUser')
    const commerceData: ICommerceBO = commerce ? JSON.parse(commerce) : null
    return fetch(
        `${BASEAPI}apimac/api/v1/mac/product/stock/${productID}/store/${getLocalId()}`,
        {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Authorization: getJWT(),
            },
            body: JSON.stringify({
                stock: stock,
                sellingByEcommerce: true,
                sellingByPickandgo: true,
                weight: weight && +weight.replace(',', '.'),
                weightUnit,
                f2f,
                online,
            }),
        }
    )
}

const changePrice = (
    price: string,
    productID: number,
    priceTypeID: number,
    costPrice: string
) => {
    const commerce = localStorage.getItem('currentUser')
    const commerceData: ICommerceBO = commerce ? JSON.parse(commerce) : null
    const internalID = commerceData.sEstablecimiento + getLocal()
    return fetch(
        `${BASEAPI}apimac/api/v1/mac/product/price/${productID}/store/${getLocalId()}`,
        {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Authorization: getJWT(),
            },
            body: JSON.stringify({
                productID: productID,
                commerceInternalID: internalID,
                active: true,
                discount: 0,
                priceTypeID: priceTypeID,
                saleAmount: Number(price),
                cost: costPrice,
            }),
        }
    )
}
const addPrice = (
    price: string,
    priceOriginal: string,
    productID: number,
    priceTypeID: number
) => {
    const commerce = localStorage.getItem('currentUser')
    const commerceData: ICommerceBO = commerce ? JSON.parse(commerce) : null
    const internalID = commerceData.sEstablecimiento + getLocal()
    return fetch(
        `${BASEAPI}apimac/api/v1/mac/product/price/${productID}/store/${getLocalId()}`,
        {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Authorization: getJWT(),
            },
            body: JSON.stringify({
                productID: productID,
                commerceInternalID: internalID,
                active: true,
                discount: 0,
                priceTypeID: priceTypeID,
                saleAmount: Number(price),
                priceOriginal: priceOriginal,
            }),
        }
    )
}

const getBrands = async () => {
    const jwt = getJWT()
    const query = await fetch(`${BASEAPI}apimac/api/v1/mac/product/brands`, {
        headers: { Authorization: jwt },
    })
    const data = await query.json()
    localStorage.setItem('brands', JSON.stringify(data))
}

const getEAN = async (ean: string) => {
    const jwt = getJWT()
    const query = await fetch(
        `${BASEAPI}apimac/api/v1/mac/product/suggestion?ean=${ean}&page=1&chunk=10`,
        { headers: { Authorization: jwt } }
    )
    const data = await query.json()
    console.log('GET EAN', data)

    return data
}

const getCategories = async () => {
    const query = await fetch(
        `${BASEAPI}apimac/api/v1/mac/product/categories?only_child=true`,
        { headers: { Authorization: getJWT() } }
    )
    const data = await query.json()
    localStorage.setItem('categories', JSON.stringify(data))
}

const localBrands = (): IBrand[] => {
    const brands = localStorage.getItem('brands') || ''
    return JSON.parse(brands)
}
const localEans = (): IEan[] => {
    const eans = localStorage.getItem('eans') || ''
    console.log('AAA', JSON.parse(eans))
    return JSON.parse(eans)
}
const localCategories = (): ICategory[] => {
    const categories = localStorage.getItem('categories') || ''
    return JSON.parse(categories)
}

const uploadImage = async (image: string) => {
    const commerce = localStorage.getItem('currentUser')
    const commerceData: ICommerceBO = commerce ? JSON.parse(commerce) : null
    return fetch(`${BASEAPI}APIUploadImages/product/store/${getLocalId()}`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            Authorization: getJWT(),
        },

        body: JSON.stringify({ image }),
    })
        .then(async (res) => {
            return JSON.parse(await res.text()).url
        })
        .catch(() => {
            return false
        })
}

const getProducts = async (
    filter: string,
    page: number,
    chunk: number,
    category: string,
    name: string,
    sortName: string,
    sortPrice: string
) => {
    const local = localStorage.getItem('selectedLocalId')

    const query = await fetch(
        `${BASEAPI}apimac/api/v1/mac/product/pages/ecommerce/store/${local}?filter=${filter}&page=${page}&chunk=${chunk}&category=${category}&product_name=${name.replaceAll(
            ' ',
            ''
        )}&sortName=${sortName}&sortPrice=${sortPrice}`,
        {
            headers: {
                Authorization: getJWT(),
            },
        }
    )
    const data = await query.json()

    localStorage.setItem('products', JSON.stringify(data))

    return data
}

const localProducts = (): IProductsWithPage => {
    const products = localStorage.getItem('products') || ''
    return JSON.parse(products)
}

const getCategoriesByCommerce = async () => {
    const query = await fetch(
        `${BASEAPI}apimac/api/v1/mac/product/categories/ecommerce/store/${getLocalId()}`,
        {
            headers: {
                Authorization: getJWT(),
            },
        }
    )
    const data = await query.json()
    localStorage.setItem('categoriesCommerce', JSON.stringify(data))
}

const localCategoriesCommerce = (): ICategory[] => {
    const categories = localStorage.getItem('categoriesCommerce') || '[]'
    return JSON.parse(categories)
}

const liquidateFromStock = async (data: ICreateLiquidateStock) => {
    const commerce = localStorage.getItem('currentUser')
    const commerceData: ICommerceBO = commerce ? JSON.parse(commerce) : null
    const internalID = commerceData.sEstablecimiento + getLocal()

    const res = await fetch(
        `${BASEAPI}apimac/api/v1/mac/product/settlement/stock`,
        {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Authorization: getJWT(),
            },
            body: JSON.stringify({
                commerceInternalID: internalID,
                sku: data.sku,
                dateVoidSettlement: data?.dateVoidSettlement
                    ? format(data.dateVoidSettlement, 'yyyy-MM-dd')
                    : null,
                saleAmount: data.saleAmount,
                stock: data.stock,
            }),
        }
    )
    return res
}

const stopLiquidatedProduct = async (productID: number) => {
    const res = await fetch(
        `${BASEAPI}apimac/api/v1/mac/product/store/${getLocalId()}/settlement/${productID}`,
        {
            method: 'DELETE',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: getJWT(),
            },
        }
    )

    return res
}

const addIngredients = async (productID: number, data: AddIngredient[]) => {
    await fetch(`${BASEAPI}apimac/api/v1/mac/product/${productID}/ingredient`, {
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: getJWT(),
        },
        body: JSON.stringify({ ingredientTypes: data }),
    })
}

const createMassiveProducts = async (products: File, images?: File) => {
    const commerce = localStorage.getItem('currentUser')
    const commerceData: ICommerceBO = commerce ? JSON.parse(commerce) : null

    const data = new FormData()
    data.append('products', products)
    const emptyFile = new File([], '')

    data.append('images', images ? images : emptyFile)

    data.append(
        'commerceInternalID',
        `${commerceData.sEstablecimiento}${getLocal()}`
    )
    return await fetch(`${BASEAPI}api-load-products/product/load`, {
        method: 'POST',
        body: data,
        headers: {
            Authorization: getJWT(),
        },
    })
}

const updateProduct = async (data: IEditProduct) => {
    return await fetch(`${BASEAPI}apimac/api/v1/mac/product`, {
        method: 'PUT',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: getJWT(),
        },
        body: JSON.stringify(data),
    })
}

const updateStock = (productID: number, data: IEditStock) => {
    return fetch(
        `${BASEAPI}apimac/api/v1/mac/product/stock/${productID}/store/${getLocalId()}`,
        {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Authorization: getJWT(),
            },
            body: JSON.stringify(data),
        }
    )
}

const updatePrice = (productID: number, data: IEditPrice) => {
    const commerce = localStorage.getItem('currentUser')
    const commerceData: ICommerceBO = commerce ? JSON.parse(commerce) : null
    const internalID = commerceData.sEstablecimiento + getLocal()
    return fetch(
        `${BASEAPI}apimac/api/v1/mac/product/price/${productID}/store/${getLocalId()}`,
        {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Authorization: getJWT(),
            },
            body: JSON.stringify(data),
        }
    )
}
const updateIngredients = async (
    productID: number,
    data: UpdateIngredient[] | IEditIngredients[]
) => {
    return await fetch(
        `${BASEAPI}apimac/api/v1/mac/product/${productID}/ingredient`,
        {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                Authorization: getJWT(),
            },
            body: JSON.stringify(data),
        }
    )
}

interface IDeleteProductService extends IProductObject {
    types: string[]
}

const deleteProduct = async (
    idProducto: number,
    data: IDeleteProductService
) => {
    return await fetch(
        `${BASEAPI}apimac/api/v1/mac/product/store/${getLocalId()}/stock/deactive/${idProducto}`,
        {
            method: 'PUT',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: getJWT(),
            },
            body: JSON.stringify(data),
        }
    )
}

const getProduct = async (
    idProducto: number,
    internalIdCommerce: number
): Promise<IProductObject> => {
    const query = await fetch(
        `${BASEAPI}apimac/api/v1/mac/product/${idProducto}/store/${String(
            internalIdCommerce
        ).slice(-3)}`,
        {
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: getJWT(),
            },
        }
    )
    return (await query.json()) as IProductObject
}

const getInPersonProducts = async (
    page: number,
    chunk: number,
    name: string
) => {
    const query = await fetch(
        `${BASEAPI}apimac/api/v1/mac/product/pages/ecommerce/store/${getLocalId()}?&sortName=asc&filter=F2F&page=${page}&chunk=${chunk}&product_name=${name.replaceAll(
            ' ',
            ''
        )}`,
        {
            headers: {
                Authorization: getJWT(),
            },
        }
    )

    return (await query.json()) as IProductsWithPage
}

const getPlanDetails = async (id: number) => {
    const response = await fetch(
        `https://servicesamipos.amipass.com/amipos/v2/plans/${id}/details`,
        {
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: getJWT(),
            },
        }
    )

    if (!response.ok) {
        throw new Error(`Error al obtener el plan: ${response.statusText}`)
    }

    return await response.json()
}

export {
    createProduct,
    liquidateFromCreate,
    uploadImage,
    addStock,
    changePrice,
    getBrands,
    getCategories,
    localBrands,
    localCategories,
    getProducts,
    localProducts,
    getCategoriesByCommerce,
    localCategoriesCommerce,
    liquidateFromStock,
    stopLiquidatedProduct,
    addIngredients,
    createMassiveProducts,
    updateProduct,
    updateStock,
    updatePrice,
    updateIngredients,
    deleteProduct,
    getProduct,
    addPrice,
    getEAN,
    localEans,
    getInPersonProducts,
    getPlanDetails,
}
